import { AnyAction } from 'redux';
import { UserSortReducer } from './user-sort';
import { UserFilterReducer } from './user-filter';
import { ModalsReducer } from './modals';
import { RowsReducer } from './rows';
import { ToolsBarReducer } from './tools-bar';

// Sub-reducers are still-untyped `.js`, so their slice shapes resolve as `any`.
interface CloudAdminState {
  toolsBar: ReturnType<typeof ToolsBarReducer>;
  userSort: ReturnType<typeof UserSortReducer>;
  userFilter: ReturnType<typeof UserFilterReducer>;
  modals: ReturnType<typeof ModalsReducer>;
  rows: ReturnType<typeof RowsReducer>;
}

const initialState = {} as CloudAdminState;

export default function CloudAdmin(
  state: CloudAdminState = initialState,
  action: AnyAction,
): CloudAdminState {
  return {
    toolsBar: ToolsBarReducer(state.toolsBar, action),
    userSort: UserSortReducer(state.userSort, action),
    // UserFilterReducer narrows its action to a shape with required filter
    // fields; the dispatchers (untyped .js) always supply them at runtime.
    userFilter: UserFilterReducer(
      state.userFilter,
      action as Parameters<typeof UserFilterReducer>[1],
    ),
    modals: ModalsReducer(state.modals, action),
    rows: RowsReducer(state.rows, action),
  };
}
